import React from 'react';
import Logo from './../../assets/images/logo.svg';

// LoginForm stateless component
const LoginForm = () =>
	<form className="box">
		{/* Logo */}
		<div className="field has-text-centered">
			<img src={Logo} width="167" alt="Form Logo" />
		</div>

		{/* Email input */}
		<div className="field">
			<label className="label">Email</label>
			<div className="control has-icons-left">
				<input className="input" type="email" placeholder="e.g. alexjohnson@gmail.com" />
				<span className="icon is-small is-left">
					<i className="fa fa-envelope"></i>
				</span>
			</div>
		</div>

		{/* Password input */}
		<div className="field">
			<label className="label">Password</label>
			<div className="control has-icons-left">
				<input className="input" type="password" placeholder="********" required />
				<span className="icon is-small is-left">
					<i className="fa fa-lock"></i>
				</span>
			</div>
		</div>

		{/* Login button */}
		<div className="field">
			<button className="button is-success">
				Login
			</button>
		</div>
	</form>

export default LoginForm;




// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js